import { FenceTypeBase } from './base/fence-type-base';

export class FenceType extends FenceTypeBase { }